export default "__VITE_ASSET__BSMt$QKG__"